export default __webpack_public_path__ + "ece7cbb712741f7556047963c40198e6.svg";